<template>
  <section>
    <div class="tip" style="margin:25px 0 0 20px">* 基本资料</div>
    <ul class="project-info-list">
      <li>
        <label>申请人所在单位：</label>
        <div class="info-item">{{ form.department.name }}</div>
      </li>
      <li>
        <label>审批申请人：</label>
        <div class="info-item">{{ form.creator.name }}</div>
      </li>
      <li>
        <label>联系方式：</label>
        <div class="info-item">{{ form.creator.mobile }}</div>
      </li>

      <li>
        <label>供应商名称：</label>
        <div class="info-item">{{ form.name }}</div>
      </li>
      <li class="block intro-box">
        <label>采购货物名称：</label>
        <div class="info-item">{{ form.productName }}</div>
      </li>
      <li class="block intro-box">
        <label>备注：</label>
        <div class="info-item">{{ form.remark }}</div>
      </li>
    </ul>
  </section>
</template>
<script>
  export default {
    props: ['form', 'userData'],
    data() {
      return {}
    },
    mounted() {},
    methods: {}
  }
</script>


// WEBPACK FOOTER //
// src/page/user/projectinfo/purchaseSupplierApply.vue